import React from "react";

const NonTeachingStaffFooter = () => {
  return (
    <footer className="bg-white border-t py-4 px-6 text-center text-gray-500 text-sm">
      Copyright © Agnel School Of Law
    </footer>
  );
};

export default NonTeachingStaffFooter;